const initThumbNavigation = (slider, oFlickitySlider) => {
  const oSliderContainer = slider.closest('.js-slider-container');
  const oThumbContainer = oSliderContainer.querySelector('.js-slider-thumbs');

  if (oThumbContainer) {
    const oThumbs = oThumbContainer.children;

    oFlickitySlider.on('change', (i) => {
      [].forEach.call(oThumbs, (thumb => thumb.classList.remove('active')));
      oThumbs[i].classList.add('active');
    });

    for (let i = 0; i < oThumbs.length; i += 1) {
      oThumbs[i].addEventListener('click', () => {
        [].forEach.call(oThumbs, (thumb => thumb.classList.remove('active')));
        oThumbs[i].classList.add('active');
        oFlickitySlider.select(i, false, true);
      });
    }
  }
};

function fSliders() {
  const aSliders = document.querySelectorAll('.js-slider');

  const sliderNextPrev = (control, slider) => {
    slider.stopPlayer();
    if (control.classList.contains('next')) {
      slider.next(false, false);
    } else {
      slider.previous(false, false);
    }
    if (slider.options.autoPlay) {
      slider.playPlayer();
    }
  };

  const handleSliderControlState = (index, controls, oFlickitySlider) => {

    const iNumberOfSliders = oFlickitySlider.slides.length;

    for (let i = 0; i < controls.length; i += 1) {
      const control = controls[i];

      if (index === 0) {
        if (control.classList.contains('prev')) {
          control.setAttribute('disabled', '');
        } else if (control.classList.contains('next')) {
          control.removeAttribute('disabled');
        }
      } else if (index === iNumberOfSliders - 1) {
        if (control.classList.contains('next')) {
          control.setAttribute('disabled', '');
        } else {
          control.removeAttribute('disabled', '');
        }
      } else if (control.getAttribute('disabled') != null) {
        control.removeAttribute('disabled');
      }
    }
  };

  const bindSliderControlEvents = (controls, oFlickitySlider) => {
    for (let i = 0; i < controls.length; i += 1) {
      controls[i].addEventListener('click', () => sliderNextPrev(controls[i], oFlickitySlider));
    }

    const iNumberOfSliders = oFlickitySlider.slides.length;

    if (iNumberOfSliders <= 1) {
        for (let i = 0; i < controls.length; i += 1) {
            const control = controls[i];
            control.setAttribute('disabled', '');
        }
    } 

    oFlickitySlider.on('change', (index) => {
        handleSliderControlState(index, controls, oFlickitySlider);
    });
  };

  const initSliderNavigation = (slider, oFlickitySlider) => {
    const oSliderContainer = slider.closest('.js-slider-container');
    const aSliderControls = oSliderContainer.querySelectorAll('.js-slider-control');

    if (aSliderControls.length) {
      bindSliderControlEvents(aSliderControls, oFlickitySlider);
    }
  };

  const initSliderZoom = (slider, oFlickitySlider) => {
      oFlickitySlider.on('staticClick', (e, pointer, cellElement, cellIndex) => {
          if (e.srcElement.id !== "collectionpdfopener") {
              createZoom(e, pointer, cellElement, cellIndex);
          }
      });
  };

  const initSliderZoom2 = (slider, oFlickitySlider) => {
    oFlickitySlider.on('staticClick', (e, pointer, cellElement, cellIndex) => {
        if (e.srcElement.id !== "collectionpdfopener") {
            createZoom2(e, pointer, cellElement, cellIndex);
        }
    });
  };

  const initOptionSlide = (slider, oFlickitySlider) => {
    const oOptionNameContainer = slider.parentElement.querySelector('[data-name]');
    const oOptionPriceContainer = slider.parentElement.querySelector('[data-price]');
    const oOptionOldPriceContainer = slider.parentElement.querySelector('[data-oldprice]');

    oFlickitySlider.on('change', (i) => {
      if (typeof oFlickitySlider.navCompanion != 'undefined') {
        oFlickitySlider.navCompanion.select(i, false, true);

        const sOptionName = oFlickitySlider.cells[i].element.dataset.optionName;
        const sOptionPrice = oFlickitySlider.cells[i].element.dataset.optionPrice;
        const sOptionOldPrice = oFlickitySlider.cells[i].element.dataset.optionOldprice;

        oOptionNameContainer.textContent = sOptionName;
        oOptionPriceContainer.textContent = sOptionPrice;
        oOptionOldPriceContainer.textContent = sOptionOldPrice;
      }
    });
  };

  const sliderReadyCallback = (slider, flickitySlider) => {
    if (slider.getAttribute('data-slider-customnav') === 'true') {
      initSliderNavigation(slider, flickitySlider);
    }

    if (slider.getAttribute('data-slider-thumbs') === 'true') {
      initThumbNavigation(slider, flickitySlider);
    }

    if (slider.getAttribute('data-slider-zoom') === 'true') {
      initSliderZoom(slider, flickitySlider);
    }

    if (slider.getAttribute('data-slider-zoom2') === 'true') {
      initSliderZoom2(slider, flickitySlider);
    }

    if (slider.closest('.js-slider-container')) {
      const oSliderContainer = slider.closest('.js-slider-container');
      oSliderContainer.classList.add('ready');
    }

    if (slider.classList.contains('slider--options')) {
      initOptionSlide(slider, flickitySlider);
    }
  };

  const createSlider = (oSlider) => {

      var showonLastCell = oSlider.getAttribute('data-showonlastcell') ? oSlider.getAttribute('data-showonlastcell') : '';
      var hideonLastCell = oSlider.getAttribute('data-hideonlastcell') ? oSlider.getAttribute('data-hideonlastcell') : '';

    //imagesLoaded(oSlider, () => {
      const oFlickitySlider = new Flickity(oSlider, {
        initialIndex: ".is-initial-select",
        autoPlay: oSlider.getAttribute('data-autoplay') ? parseInt(oSlider.getAttribute('data-autoplay'), 10) : false,
        pauseAutoPlayOnHover: oSlider.getAttribute('data-pauseautoplay') === null,
        cellAlign: oSlider.getAttribute('data-slider-align') ? oSlider.getAttribute('data-slider-align') : 'left',
        wrapAround: oSlider.getAttribute('data-slider-wrap') === 'true',
        fade : oSlider.getAttribute('data-slider-fade') === 'true',
        prevNextButtons: oSlider.getAttribute('data-slider-nav') === 'true',
        adaptiveHeight: oSlider.getAttribute('data-slider-adaptive') === 'true',
        pageDots: oSlider.getAttribute('data-slider-dots') === 'true',
        draggable: oSlider.getAttribute('data-slider-drag') === 'false' ? false : '>1',
        lazyLoad: oSlider.getAttribute('data-slider-lazy') ? oSlider.getAttribute('data-slider-lazy') === 'true' ? true : parseInt(oSlider.getAttribute('data-slider-lazy'), 10) : false,
        asNavFor: oSlider.getAttribute('data-slider-navfor') ? document.querySelector(`[data-option-slider="${oSlider.getAttribute('data-slider-navfor')}"]`) : false,
        watchCSS: oSlider.getAttribute('data-watch-css') === 'true',
        groupCells: oSlider.getAttribute('data-groupcells') ? oSlider.getAttribute('data-groupcells') : false,        
        contain: oSlider.getAttribute('data-contain') === 'true',
          on: {
              scroll: function (progress) {

                  if (oSlider.getAttribute('data-contain') === 'true') {
                      var oSliderContainer = oSlider.closest('.js-slider-container');
                      if (oSliderContainer) {
                          var aSliderControls = oSliderContainer.querySelectorAll('.js-slider-control');
                          if (aSliderControls && aSliderControls.length) {

                              if (Number.isFinite(progress)) {
                                  progress = Math.max(0, Math.min(1, progress));
                              }

                              for (let i = 0; i < aSliderControls.length; i += 1) {
                                  var control = aSliderControls[i];

                                  if (control.classList.contains('prev')) {
                                      if (!Number.isFinite(progress) || progress < 0.01) {
                                          control.setAttribute('disabled', '');
                                      }
                                      else {
                                          control.removeAttribute('disabled');
                                      }
                                  }
                                  else if (control.classList.contains('next')) {
                                      if (!Number.isFinite(progress) || progress > 0.94) {
                                          control.setAttribute('disabled', '');
                                      }
                                      else {
                                          control.removeAttribute('disabled');
                                      }
                                  }
                              }
                          }
                      }
                  }
              },
            ready: () => {
            if (document.querySelector('.js-product-detail')) {
              app.$refs.productdetailNonConfigurable.onSliderReady();
            }

            if (document.querySelector('.js-product-detail-config')) {
              app.$refs.productdetailConfigurable.onSliderReady(oSlider);
            }

            setTimeout(() => {
              sliderReadyCallback(oSlider, oFlickitySlider);
            }, 0);
          },
          dragEnd: () => {
            if (oFlickitySlider.options.autoPlay) {
              oFlickitySlider.playPlayer();
            }
          },
          settle: () => {
            if (hideonLastCell !== '' && showonLastCell !== '' && oFlickitySlider.selectedIndex === oFlickitySlider.cells.length - 1) {

                const showElement = document.querySelector('#' + showonLastCell);
                if (showElement) {
                    showElement.style.display = "";
                }

                const hideElement = document.querySelector('#' + hideonLastCell);
                if (hideElement) {
                    hideElement.style.display = "none";
                }
            }
          }
        },
      });

      if (hideonLastCell !== '') {
          const hideElement = document.querySelector('#' + hideonLastCell);
          if (hideElement) {
              hideElement.addEventListener('click', () => {
                  oFlickitySlider.next();
              });
          }
      }

      // If Slider contains an Accordion
      // Watch the styles on the collapse and resize() the Slider
      if (oSlider.querySelector('.js-accordion')) {
        const oAccordionInSlider = oSlider.querySelector('.js-accordion-collapse');
        const observer = new MutationObserver(((mutations) => {
          mutations.forEach((mutationRecord) => {
            if (mutationRecord.attributeName === 'style') {
              // Timeout because the accordion has a transition of .25s
              setTimeout(() => {
                oFlickitySlider.resize();
              }, 250);
            }
          });
        }));

        observer.observe(oAccordionInSlider, {
          attributes: true,
          subtree: true,
        });
      }

      // Custom tab navigation
      if (oSlider.getAttribute('data-slider-tabs') === 'true') {
        const oNavigation = document.querySelector('.js-slider-tabs');
        const aNavigationItems = oNavigation.querySelectorAll('.slider-tabs__item');

        oFlickitySlider.on('change', (index) => {
          aNavigationItems.forEach((navItem) => {
            navItem.classList.remove('is-active');
          });

          aNavigationItems[index].classList.add('is-active');
        });

        if (window.location.hash.indexOf('hours') > -1) {
          aNavigationItems.forEach((navItem, index) => {
            navItem.classList.remove('is-active');
            if (navItem.getAttribute('data-id') === window.location.hash) {
              navItem.classList.add('is-active');
              oFlickitySlider.select(index, false, true);
            }
          });
        }

        aNavigationItems.forEach((navItem, index) => {
          navItem.addEventListener('click', () => {
            aNavigationItems.forEach(item => item.classList.remove('is-active'));

            navItem.classList.add('is-active');
            oFlickitySlider.select(index, false, false);
          });
        });
      }
    //});
  };

  for (let i = 0; i < aSliders.length; i += 1) {
      if (!aSliders[i].classList.contains('flickity-enabled')) {

          if (aSliders[i].classList.contains('slider--hidden')) {
              aSliders[i].classList.remove('slider--hidden');
          }

          createSlider(aSliders[i]);

      }
  }
}
